import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";

class DashboardStatementsWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.setState({
      ...this.component.state,
      ...this.component.props.app.statementsFilterCheckBoxState
    }, () => {
        this.component.fetchFirstNotSentStatements(() => {
          window.scrollTo({
            top: this.component.props.app?.dashboardStatementsListPosition
          });
        });
    })
  }
}

export default new DashboardStatementsWillMount();
